import {
    GET_TIPOS_GASTO,
    ADD_TIPO_GASTO,
    MODIFY_TIPO_GASTO,
    DELETE_TIPO_GASTO,
    UPDATE_TIPOS_GASTO
} from '../constants/action_types';

const initialState = {
    tiposgasto: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPOS_GASTO:

            return {
                tiposgasto: [],
                isLoading: true
            };
        case GET_TIPOS_GASTO + "_SUCCESS":

            return {
                tiposgasto: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_GASTO:

            const newArr = [...state.tiposgasto, action.payload]
            return {
                tiposgasto: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_GASTO:

            return {
                tiposgasto: state.tiposgasto.map((tipoGasto) => {
                    if (tipoGasto.id !== action.payload.id) return tipoGasto;
                    else return action.payload
                }),
                isLoading: false
            };


        case DELETE_TIPO_GASTO:

            return {
                tiposgasto: state.tiposgasto.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPOS_GASTO + "_SUCCESS":

            return state;

        default:

            return state;
    }
}